import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <h4>
    Les informations renseignées ici décrivent l'historique et les antécédents
    médicaux du patient atteint de dépression
  </h4>

  <div class='field'>
    <@form.Date @labelName='Date de diagnostic' @propertyName='diagnosisDate' />
  </div>

  <div class='field'>

    <@form.FieldsRadioGroup
      @title='Diagnostic'
      @translationKey='fur.mental-main-diag'
      @propertyName='mainDiagnosis'
      as |Group|
    >
      <Group.FieldRadio @value='lightDepression' />
      <Group.FieldRadio @value='mediumDepression' />
      <Group.FieldRadio @value='persistingDepression' />
      <Group.FieldRadio @value='unknown' />
    </@form.FieldsRadioGroup>
  </div>

  <div class='field'>

    <@form.AlignedFieldsRadioGroup
      @propertyName='suicideRisk'
      @title='Risque suicidaire'
      as |Group|
    >
      <Group.FieldRadio @label='Oui' @value={{true}} />
      <Group.FieldRadio @label='Non' @value={{false}} />
      <Group.FieldRadio @label='Non précisé' @value={{null}} />
    </@form.AlignedFieldsRadioGroup>
  </div>

  <div class='field'>

    <@form.Date
      @labelName='Date de début des pensées suicidaires'
      @propertyName='suicidalThoughtsStartDate'
    />
  </div>

  <div class='field'>

    <@form.NumberInput
      @labelName='Nombre de tentatives de suicide'
      @propertyName='numberOfTs'
    />
  </div>
</template> satisfies TOC<{
  Args: {
    index?: unknown;
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
